import { keys, orderBy, values } from 'lodash';

export function subjectMap(state) {
  return state.subjectMap;
}

export function subjectIds(state) {
  return orderBy(keys(state.subjectMap).filter(id => id !== '9999'), parseInt);
}

export function gradeMap(state) {
  return state.gradeMap;
}

export function gradeIds(state) {
  return orderBy(keys(state.gradeMap).filter(id => id !== '9999'), parseInt);
}

export function coreConcepts(state) {
  return state.coreConcepts;
}

export function units(state) {
  return state.units;
}

export function coreConceptList(state) {
  return values(state.coreConcepts);
}

export function domainList(state) {
  return values(state.domains);
}

export function unitList(state) {
  return values(state.units);
}

export function pageTypes(state) {
  return state.pageTypes;
}

export function subjectGrades(state) {
  return state.subjectGrades;
}
